import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';

// 半小时检查一次waf token是否过期
const interval = 30 * 60 * 1000;
const useCheckWafToken = () => {
  const [loaded, setLoaded] = useState<boolean>(false);
  const timeRef = useRef<any>('');
  const router = useRouter();

  const changeToLoaded = () => {
    setLoaded(true);
    // js加载完毕之后3030分钟之后触发更新waf token
    checkToken({
      immediately: false
    });
  };
  const checkToken = ({ immediately = false }: { immediately: boolean }) => {
    timeRef.current = setTimeout(
      () => {
        if (window.AwsWafIntegration) {
          window.AwsWafIntegration.forceRefreshToken?.();
        }
        timeRef.current = setTimeout(() => {
          if (window.AwsWafIntegration) {
            window.AwsWafIntegration.forceRefreshToken?.();
          }
        }, interval);
      },
      immediately ? 0 : interval
    );
  };

  useEffect(() => {
    const handleRouteChangeStart = url => {
      let path = url.replace(/^(\/)?(zht|zh|en|es|ko|ja|vi|th)?/, '') || '/?';
      if (
        [
          '/?',
          '/account',
          '/account/settings/payment-method',
          '/account/login',
          '/account/signup',
          '/order/checkout'
        ].some(item => path.includes(item))
      ) {
        // 路由优化触发waf token更新，而且必须立即出发更新, 然后半个小时之后再检查 waf token
        checkToken({
          immediately: true
        });
      }
    };

    if (loaded) {
      router.events.on('routeChangeComplete', handleRouteChangeStart);
    }
    return () => {
      if (loaded) {
        router.events.off('routeChangeComplete', handleRouteChangeStart);
      }
      if (timeRef.current) {
        clearTimeout(timeRef.current);
      }
    };
  }, [loaded]);

  return {
    checkToken,
    changeToLoaded
  };
};

export default useCheckWafToken;
